export { default as LoyaltyButtonArrayWidget } from './loyalty-button-array-widget';
